import UaePassResource from 'flow/api/uaepass';
import { ApiError } from 'flow/types/Api';
import { Callback } from 'flow/types/HomeClient';
import {
    UaePassError,
    UaePassFinishResponse,
    UaePassLoginData,
    UaePassLogoutData,
    UaePassFinishRequest,
} from 'flow/types/UaePassLogin';
import { uaePassErrors } from 'flow/constants/uae-pass/uae-pass-constants';

const createCallback = <T>(
    resolve: (value: T) => void,
    reject: (reason: ApiError) => void,
): Callback => ({
    onResult: (response: unknown) => resolve(response as T),
    onError: (error: Error) => reject(error as unknown as ApiError),
    onClientError: (error: Error) => reject(error as unknown as ApiError),
});

export const fetchUaePassSignIn = (): Promise<UaePassLoginData> =>
    new Promise((resolve, reject) => {
        UaePassResource.signIn(createCallback(resolve, reject));
    });

export const fetchUaePassFinish = (
    finishRequest: UaePassFinishRequest,
): Promise<UaePassFinishResponse> =>
    new Promise((resolve, reject) => {
        UaePassResource.finishUaePassSignIn(
            createCallback(resolve, reject),
            finishRequest,
        );
    });

export const fetchUaePassLogout = (): Promise<UaePassLogoutData> =>
    new Promise((resolve, reject) => {
        UaePassResource.getLogoutUrls(createCallback(resolve, reject));
    });

export const mapSignInErrorToUaePassError = (error: ApiError): UaePassError => {
    switch (error.status) {
        case 503:
            return uaePassErrors.SERVICE_NOT_FOUND;
        case 401:
            return uaePassErrors.NOT_AUTHENTICATED;
        case 403:
            return uaePassErrors.NOT_ELIGIBLE;
        default:
            return uaePassErrors.GENERIC;
    }
};

const isValidUaePassError = (code: string): code is UaePassError =>
    Object.values(uaePassErrors).includes(code as UaePassError);

export const parseErrorParam = (
    rawError: string | null,
): UaePassError | null => {
    if (!rawError) return null;
    if (!isValidUaePassError(rawError)) {
        const safeError = String(rawError)
            .slice(0, 50)
            .replace(/[^\w-]/g, '_');
        console.warn(
            `Unknown UAE Pass error code: ${safeError}, falling back to generic`,
        );
        return uaePassErrors.GENERIC;
    }
    return rawError;
};
